import { render, staticRenderFns } from "./DocumentsCreatePE.vue?vue&type=template&id=4bce731c&scoped=true"
import script from "./DocumentsCreatePE.vue?vue&type=script&lang=js"
export * from "./DocumentsCreatePE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce731c",
  null
  
)

export default component.exports